const CONFIG = {
ior: 1.49,
thickness: 1.15,
roughness: 0.14, // a soft satin blur of whatever is behind, so the engraving reads over busy photos
frostRoughness: 0.5, // shop scenes marked data-frost turn the block to frosted acrylic once it has landed
frostIn: 1.4, // seconds to frost over
frostOut: 0.6, // seconds to clear again
dispersion: 0.85,
clearcoat: 0.6,
envIntensity: 1.15,
glassColor: '#ffffff',
attenuationColor: '#f2eaf7',
attenuationDistance: 7,
blockW: 1.7,
blockH: 2.2,
blockDepth: 0.36,
blockRadius: 0.13,
blockBevel: 0.05,
engraveColor: '#ffffff',
engraveOpacity: 1,
photoW: 6.2,
satW: 2.5,
satBorder: 0.07, // white print border around the satellite photos
feelW: 9,
feelGap: 4.4, // between a shop scene and the moment above it
feelGapTall: 9,
feelZ: -3.2,
photoRadius: 0.08,
chapterStep: 9.6,
chapterDepth: 7.6,
chapterTurn: 0.14,
unfocusFade: 0.38,
shadowColor: '#2a1236',
shadowOpacity: 0.2,
backdropGlow: '#f3ecf7',
backdropGlowDark: '#2a1f31', // dark mode: a dim plum glow, so light text never lands on a light room
fov: 30,
camDamp: 3.2,
blockDamp: 2.1,
pullBack: 3.6,
parallax: 0.3,
lookCentre: 0.55, // 1 faces the middle only, 0 follows the pointer only
lookReach: 0.65, // how far out of the screen it looks: more turns it harder
lookYaw: 0.7, // radians it may turn away from facing the camera
lookPitch: 0.35,
travelGap: 0.9, // scenes the scroll may run ahead of the camera before it stops flying and dips instead
landSpeed: 0.6, // scenes per second: below this the reader has stopped, and the camera lands
landRun: 0.45, // how much of the flight into the scene it lands with
transitOut: 0.16, // seconds to dip to the ground
transitIn: 0.5, // seconds to lift it again over the landing
laserDuration: 2.2,
laserSweep: 6, // head passes per second
laserCore: '#fff6ea',
laserGlow: '#ff9d4d',
sparkHot: '#ffe2b0',
sparkCool: '#ff7a2e',
dustCount: 420,
dustColor: '#c9a46a',
dustOpacity: 0.55,
dustSize: 3.2,
}
const root = document.getElementById('egv4')
const story = document.getElementById('eg-story')
const veil = document.getElementById('eg-veil')
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)')
const TAU = Math.PI * 2
const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v))
const lerp = (a, b, t) => a + (b - a) * t
const smoother = (t) => t * t * t * (t * (t * 6 - 15) + 10)
const sleep = (ms) => new Promise((r) => setTimeout(r, ms))
const hexRgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16))
const rgba = (rgb, a) => `rgba(${rgb[0] | 0},${rgb[1] | 0},${rgb[2] | 0},${a.toFixed(3)})`
function mulberry32(seed) {
return () => {
seed |= 0; seed = (seed + 0x6d2b79f5) | 0
let t = Math.imul(seed ^ (seed >>> 15), 1 | seed)
t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
return ((t ^ (t >>> 14)) >>> 0) / 4294967296
}
}
let bottomInset = 0
function measureTheme() {
const top = story.getBoundingClientRect().top + window.scrollY
root.style.setProperty('--eg-top', `${Math.round(top)}px`)
const bar = document.querySelector('.t4s-toolbar')
const cs = bar && getComputedStyle(bar)
bottomInset = bar && cs.position === 'fixed' && cs.display !== 'none' ? Math.round(bar.getBoundingClientRect().height) : 0
root.style.setProperty('--eg-bottom', `${bottomInset}px`)
}
window.addEventListener('resize', () => { if (root.classList.contains('eg-is-3d')) measureTheme() }, { passive: true })
initReveals()
if (root && story) {
if (reduceMotion.matches || !hasWebGL2()) toStatic()
else start3D().catch((err) => { console.warn('[engravita] 3D story disabled:', err); toStatic() })
}
function hasWebGL2() {
try { return !!document.createElement('canvas').getContext('webgl2') } catch (e) { return false }
}
function toStatic() {
unmountSlots()
root.classList.remove('eg-is-3d', 'eg-is-ready')
document.documentElement.classList.remove('eg-snap')
}
let slotted = []
function mountSlots(stageEl, before) {
slotted = [...story.querySelectorAll('.eg-story__track > .eg-panel')].map((panel) => {
const slot = document.createElement('div')
slot.className = `${panel.className} eg-story__slot`
slot.append(...panel.childNodes)
stageEl.insertBefore(slot, before)
return { panel, slot, on: false }
})
}
function unmountSlots() {
slotted.forEach(({ panel, slot }) => { panel.append(...slot.childNodes); slot.remove() })
slotted = []
}
function initReveals() {
const els = root.querySelectorAll('.eg-reveal')
if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('eg-is-in')); return }
const io = new IntersectionObserver((entries) => {
entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('eg-is-in'); io.unobserve(e.target) } })
}, { threshold: 0.2 })
els.forEach((el, i) => { el.style.transitionDelay = `${(i % 4) * 70}ms`; io.observe(el) })
}
function splitWords(el) {
let i = 0
;[...el.childNodes].forEach((n) => {
if (n.nodeType === 3) {
const frag = document.createDocumentFragment()
n.textContent.split(/(\s+)/).forEach((part) => {
if (!part) return
if (/^\s+$/.test(part)) { frag.append(part); return }
const s = document.createElement('span')
s.className = 'eg-w'
s.style.setProperty('--i', i++)
s.textContent = part
frag.append(s)
})
n.replaceWith(frag)
} else if (n.nodeType === 1) {
n.classList.add('eg-w')
n.style.setProperty('--i', i++)
}
})
}
async function loadThree() {
const inline = document.getElementById('three-src')
if (inline) {
const bin = atob(inline.textContent.trim())
const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0))
return import(URL.createObjectURL(new Blob([bytes], { type: 'text/javascript' })))
}
return import(root.dataset.three).catch(() => import(root.dataset.threeFallback)) // three.js r170 (MIT), pinned
}
async function start3D() {
root.classList.add('eg-is-3d')
document.documentElement.classList.add('eg-snap')
measureTheme()
story.querySelectorAll('.eg-feel__title, .eg-finale__title').forEach(splitWords)
const floor = sleep(950)
let opened = false
let onOpen = () => {}
const openGate = () => {
if (opened) return
opened = true
root.classList.add('eg-is-ready')
veil.classList.add('eg-is-out')
onOpen()
setTimeout(() => veil.classList.add('eg-is-gone'), 1100)
}
const cap = setTimeout(openGate, 3600)
const THREE = await loadThree()
const scene = await createStory(THREE)
onOpen = scene.enter
if (opened) scene.enter()
await floor
clearTimeout(cap)
openGate()
}
async function createStory(THREE) {
const canvas = document.getElementById('eg-gl')
const stageEl = canvas.parentElement
const hdrEl = document.querySelector('.t4s-section-header') || document.querySelector('header')
const hotLayer = document.getElementById('eg-hotspots')
const navLinks = [...document.querySelectorAll('#eg-chapters a')]
const finaleEl = document.getElementById('eg-finale')
const transitEl = document.getElementById('eg-transit')
const [transitKicker, transitTitle] = transitEl.children
const V3 = THREE.Vector3
const parseShot = (el) => {
const img = el.querySelector('img')
const num = (k, d) => (el.dataset[k] !== undefined ? parseFloat(el.dataset[k]) : d)
return {
kind: el.dataset.shot,
img,
aspect: img.height / img.width,
fx: num('fx', 0.5), fy: num('fy', 0.5), bx: num('bx', 0.2), by: num('by', 0.35), bs: num('bs', 1),
pbx: num('pbx', 0.72), pby: num('pby', 0.3), // where the block floats on phones, clear of faces
hots: [...el.querySelectorAll('.eg-hot')].map((a) => ({
href: a.href,
html: a.querySelector('.eg-hot__tag').innerHTML,
u: parseFloat(a.style.getPropertyValue('--x')) / 100,
v: parseFloat(a.style.getPropertyValue('--y')) / 100,
})),
}
}
const chapters = [...story.querySelectorAll('.eg-feel')].map((feelEl) => {
const el = document.getElementById(`${feelEl.id}-produkter`)
return {
feelEl,
copyEl: feelEl.querySelector('.eg-feel__copy'),
engrave: feelEl.dataset.engrave,
sub: feelEl.dataset.engraveSub || '',
feel: parseShot(feelEl.querySelector('[data-shot]')),
shots: [...el.querySelectorAll('[data-shot]')].map(parseShot),
frost: el.hasAttribute('data-frost'),
on: false,
}
})
const N = chapters.length
const L = 2 * N + 1 // legs: intro, then (moment, shop) per chapter, then the finale
mountSlots(stageEl, hotLayer)
const slotOf = (el) => (slotted.find((x) => x.panel === el) || { slot: el }).slot
chapters.forEach((c) => { c.feelEl = slotOf(c.feelEl) })
const finaleSlot = slotOf(finaleEl)
const FEEL = (i) => 1 + 2 * i
const SHOP = (i) => 2 + 2 * i
const small = Math.min(screen.width, screen.height) < 700
const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, powerPreference: 'high-performance' })
renderer.setPixelRatio(Math.min(window.devicePixelRatio, small ? 1.5 : 1.75))
renderer.outputColorSpace = THREE.SRGBColorSpace
renderer.toneMapping = THREE.NeutralToneMapping
const scene = new THREE.Scene()
const camera = new THREE.PerspectiveCamera(CONFIG.fov, 1, 0.1, 400)
const ground = new THREE.Color()
const glow = new THREE.Color()
const readGround = () => {
ground.setStyle(getComputedStyle(root).getPropertyValue('--ground').trim() || '#fbf9fc')
glow.set(ground.getHSL({}).l < 0.4 ? CONFIG.backdropGlowDark : CONFIG.backdropGlow)
scene.background = ground
}
readGround()
const pmrem = new THREE.PMREMGenerator(renderer)
const studio = new THREE.Scene()
studio.add(new THREE.Mesh(new THREE.BoxGeometry(24, 14, 24), new THREE.MeshBasicMaterial({ color: 0xb4abba, side: THREE.BackSide })))
const softbox = (w, h, x, y, z, color, power) => {
const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: new THREE.Color(color).multiplyScalar(power), side: THREE.DoubleSide }))
m.position.set(x, y, z)
m.lookAt(0, 0, 0)
studio.add(m)
}
softbox(10, 3, 0, 6.5, 0, '#ffffff', 6)
softbox(2.4, 9, -11, 1, 3, '#fff0de', 3.4)
softbox(2.4, 9, 11, 1, -3, '#efe2ff', 3)
softbox(12, 4, 0, 0, -11.5, '#ffffff', 1.4)
scene.environment = pmrem.fromScene(studio, 0.035).texture
const PHOTO_VERT = `
varying vec2 vUv;
void main() { vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }`
const PHOTO_FRAG = `
uniform sampler2D map;
uniform vec2 size;
uniform float radius;
uniform float focus;
uniform float loaded;
uniform float fade;
uniform vec3 ground;
varying vec2 vUv;
float sdBox(vec2 p, vec2 b, float r) { vec2 q = abs(p) - b + r; return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0) - r; }
void main() {
vec2 p = (vUv - 0.5) * size;
if (sdBox(p, size * 0.5, radius) > 0.0) discard;
vec3 c = mix(ground, texture2D(map, vUv).rgb, loaded);
float f = clamp(focus, 0.0, 1.0);
float g = dot(c, vec3(0.2126, 0.7152, 0.0722));
c = mix(vec3(g), c, 0.4 + 0.6 * f);
c = mix(ground, c, 1.0 - fade * (1.0 - f));
gl_FragColor = vec4(c, 1.0);
#include <colorspace_fragment>
}`
const MAT_FRAG = `
uniform vec2 size;
uniform float radius;
uniform float border;
uniform float focus;
uniform float fade;
uniform vec3 ground;
varying vec2 vUv;
float sdBox(vec2 p, vec2 b, float r) { vec2 q = abs(p) - b + r; return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0) - r; }
void main() {
vec2 outer = size + border * 2.0;
if (sdBox((vUv - 0.5) * outer, outer * 0.5, radius + border) > 0.0) discard;
gl_FragColor = vec4(mix(ground, vec3(1.0), 1.0 - fade * (1.0 - clamp(focus, 0.0, 1.0))), 1.0);
#include <colorspace_fragment>
}`
const SHADOW_FRAG = `
uniform vec2 size;
uniform float radius;
uniform vec3 color;
uniform float opacity;
uniform float spread;
varying vec2 vUv;
float sdBox(vec2 p, vec2 b, float r) { vec2 q = abs(p) - b + r; return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0) - r; }
void main() {
vec2 p = (vUv - 0.5) * (size + spread * 2.0);
float d = sdBox(p, size * 0.5, radius);
float a = (1.0 - smoothstep(-spread * 0.6, spread, d)) * opacity;
gl_FragColor = vec4(color, a);
#include <colorspace_fragment>
}`
const maxAniso = renderer.capabilities.getMaxAnisotropy()
const blank = new THREE.Texture()
const jobs = []
const fading = []
const MAX = small ? { feel: 1600, main: 1200, sat: 720 } : { feel: 1800, main: 1800, sat: 1100 }
function makePhoto(shot, width, group) {
const height = width * shot.aspect
const uniforms = {
map: { value: blank },
size: { value: new THREE.Vector2(width, height) },
radius: { value: CONFIG.photoRadius },
focus: { value: 1 },
loaded: { value: 0 },
fade: { value: CONFIG.unfocusFade },
ground: { value: ground },
}
const mesh = new THREE.Mesh(new THREE.PlaneGeometry(width, height), new THREE.ShaderMaterial({ uniforms, vertexShader: PHOTO_VERT, fragmentShader: PHOTO_FRAG, toneMapped: false }))
const spread = 0.45
const shadow = new THREE.Mesh(
new THREE.PlaneGeometry(width + spread * 2, height + spread * 2),
new THREE.ShaderMaterial({
uniforms: { size: { value: new THREE.Vector2(width, height) }, radius: { value: CONFIG.photoRadius }, color: { value: new THREE.Color(CONFIG.shadowColor) }, opacity: { value: CONFIG.shadowOpacity }, spread: { value: spread } },
vertexShader: PHOTO_VERT, fragmentShader: SHADOW_FRAG, transparent: true, depthWrite: false, toneMapped: false,
}),
)
shadow.position.set(0.14, -0.26, -0.08)
mesh.add(shadow)
if (shot.kind === 'sat') {
const border = CONFIG.satBorder
const mat = new THREE.Mesh(
new THREE.PlaneGeometry(width + border * 2, height + border * 2),
new THREE.ShaderMaterial({ uniforms: { ...uniforms, border: { value: border } }, vertexShader: PHOTO_VERT, fragmentShader: MAT_FRAG, toneMapped: false }),
)
mat.position.z = -0.02
mesh.add(mat)
shadow.material.uniforms.opacity.value = CONFIG.shadowOpacity * 1.6
}
mesh.userData = { width, height, uniforms, shot, shadow: shadow.material.uniforms.opacity, shadowBase: shadow.material.uniforms.opacity.value }
jobs.push({ img: shot.img, uniforms, max: MAX[shot.kind] || MAX.sat, group })
return mesh
}
async function loadTexture(job, instant) {
const im = new Image()
im.decoding = 'async'
im.crossOrigin = 'anonymous'
im.src = job.img.src
await im.decode()
let src = im
const s = Math.min(1, job.max / Math.max(im.naturalWidth, im.naturalHeight))
if (s < 0.98) {
const c = document.createElement('canvas')
c.width = Math.round(im.naturalWidth * s)
c.height = Math.round(im.naturalHeight * s)
c.getContext('2d').drawImage(im, 0, 0, c.width, c.height)
src = c
}
const tex = new THREE.Texture(src)
tex.colorSpace = THREE.SRGBColorSpace
tex.anisotropy = Math.min(8, maxAniso)
tex.needsUpdate = true
job.uniforms.map.value = tex
if (instant) job.uniforms.loaded.value = 1
else fading.push(job.uniforms)
}
const backdrop = new THREE.Mesh(
new THREE.PlaneGeometry(1, 1),
new THREE.ShaderMaterial({
uniforms: { ground: { value: ground }, glow: { value: glow } },
vertexShader: PHOTO_VERT,
fragmentShader: `
uniform vec3 ground; uniform vec3 glow; varying vec2 vUv;
void main() {
float d = length((vUv - vec2(0.5, 0.56)) * vec2(1.6, 2.4));
gl_FragColor = vec4(mix(glow, ground, smoothstep(0.0, 0.85, d)), 1.0);
#include <colorspace_fragment>
}`,
toneMapped: false,
depthWrite: false,
}),
)
scene.add(backdrop)
const SAT_WIDE = [
[[-1.04, -0.6, 0.95, 0.035], [-1.0, 0.62, 0.7, -0.04]], // bryllup
[[-1.0, 0.62, 0.75, -0.03], [-1.04, -0.6, 0.95, 0.03]], // hjem
[[-1.04, -0.6, 0.95, 0.035], [-1.0, 0.62, 0.75, -0.035]], // baby
[[-1.0, 0.6, 0.8, -0.035], [0.66, -0.64, 1.0, 0.03]], // jul
[[-1.0, 0.62, 0.8, -0.035], [-1.04, -0.6, 0.95, 0.03]], // gaver
[[-1.04, -0.6, 0.95, 0.035], [0.66, -0.64, 1.0, -0.03]], // erhverv
]
const SAT_TALL = [[[-0.6, -1.02, 1.0, -0.03], [0.64, -1.0, 0.8, 0.04]], [[-0.6, -1.02, 1.0, 0.03], [0.64, -1.0, 0.8, -0.04]]]
const BLOCK_SHOP = [[0.86, -0.62], [0.86, -0.62], [0.86, -0.62], [0.86, 0.72], [0.86, -0.62], [0.86, 0.72]]
const Y_OFFSET = [0, 0.3, -0.25, 0.35, -0.1, 0.25]
const groups = chapters.map((ch, i) => {
const g = new THREE.Group()
g.position.set(-i * CONFIG.chapterStep, Y_OFFSET[i % Y_OFFSET.length], -i * CONFIG.chapterDepth)
g.rotation.y = CONFIG.chapterTurn
const feel = makePhoto(ch.feel, CONFIG.feelW, i)
const main = makePhoto(ch.shots.find((s) => s.kind === 'main'), CONFIG.photoW, i)
g.add(feel, main)
g.userData = { feel, main, sats: ch.shots.filter((s) => s.kind === 'sat').map((s) => { const m = makePhoto(s, CONFIG.satW, i); g.add(m); return m }) }
scene.add(g)
return g
})
backdrop.position.set(-((N - 1) * CONFIG.chapterStep) / 2, 4, -(N - 1) * CONFIG.chapterDepth - 40)
backdrop.scale.set(300, 160, 1)
const dustRnd = mulberry32(11)
const DUST_BOX = new V3(18, 12, 24)
const dustPos = new Float32Array(CONFIG.dustCount * 3)
const dustSeed = new Float32Array(CONFIG.dustCount)
for (let k = 0; k < CONFIG.dustCount; k++) {
dustPos[k * 3] = (dustRnd() - 0.5) * DUST_BOX.x
dustPos[k * 3 + 1] = (dustRnd() - 0.5) * DUST_BOX.y
dustPos[k * 3 + 2] = (dustRnd() - 0.5) * DUST_BOX.z
dustSeed[k] = dustRnd()
}
const dustGeo = new THREE.BufferGeometry()
dustGeo.setAttribute('position', new THREE.BufferAttribute(dustPos, 3))
dustGeo.setAttribute('aSeed', new THREE.BufferAttribute(dustSeed, 1))
const dustUniforms = {
uCentre: { value: new V3() },
uBox: { value: DUST_BOX },
uTime: { value: 0 },
uSize: { value: CONFIG.dustSize * renderer.getPixelRatio() },
uColor: { value: new THREE.Color(CONFIG.dustColor) },
uOpacity: { value: CONFIG.dustOpacity },
}
const dust = new THREE.Points(dustGeo, new THREE.ShaderMaterial({
uniforms: dustUniforms,
vertexShader: `
uniform vec3 uCentre; uniform vec3 uBox; uniform float uTime; uniform float uSize;
attribute float aSeed;
varying float vA;
void main() {
vec3 p = position;
p.y += uTime * (0.05 + 0.12 * aSeed);
p.x += sin(uTime * 0.23 + aSeed * 31.0) * 0.7;
p.z += cos(uTime * 0.19 + aSeed * 17.0) * 0.7;
p = mod(p - uCentre + uBox * 0.5, uBox) - uBox * 0.5 + uCentre;
vec4 mv = modelViewMatrix * vec4(p, 1.0);
gl_Position = projectionMatrix * mv;
float dist = -mv.z;
gl_PointSize = min(uSize * (0.45 + aSeed) * 12.0 / max(dist, 0.5), uSize * 4.0);
vec3 rel = abs(p - uCentre) / (uBox * 0.5);
float edge = 1.0 - smoothstep(0.72, 1.0, max(rel.x, max(rel.y, rel.z)));
vA = edge * smoothstep(1.2, 3.5, dist) * (0.5 + 0.5 * sin(uTime * 1.3 + aSeed * 40.0));
}`,
fragmentShader: `
uniform vec3 uColor; uniform float uOpacity; varying float vA;
void main() {
float a = smoothstep(0.5, 0.0, length(gl_PointCoord - 0.5));
gl_FragColor = vec4(uColor, a * a * vA * uOpacity);
#include <colorspace_fragment>
}`,
transparent: true,
depthWrite: false,
toneMapped: false,
}))
dust.frustumCulled = false
scene.add(dust)
const { blockW: bw, blockH: bh, blockDepth: bd, blockRadius: br, blockBevel: bb } = CONFIG
const shape = new THREE.Shape()
{
const w = bw - bb * 2, h = bh - bb * 2, r = br, x = -w / 2, y = -h / 2
shape.moveTo(x + r, y)
shape.lineTo(x + w - r, y); shape.absarc(x + w - r, y + r, r, -Math.PI / 2, 0, false)
shape.lineTo(x + w, y + h - r); shape.absarc(x + w - r, y + h - r, r, 0, Math.PI / 2, false)
shape.lineTo(x + r, y + h); shape.absarc(x + r, y + h - r, r, Math.PI / 2, Math.PI, false)
shape.lineTo(x, y + r); shape.absarc(x + r, y + r, r, Math.PI, Math.PI * 1.5, false)
}
const blockGeo = new THREE.ExtrudeGeometry(shape, { depth: bd - bb * 2, bevelEnabled: true, bevelThickness: bb, bevelSize: bb, bevelSegments: 6, curveSegments: 16 })
blockGeo.center()
const glass = new THREE.MeshPhysicalMaterial({
transmission: 1, thickness: CONFIG.thickness, ior: CONFIG.ior, roughness: CONFIG.roughness, dispersion: small ? 0 : CONFIG.dispersion,
clearcoat: CONFIG.clearcoat, clearcoatRoughness: 0.04, metalness: 0, specularIntensity: 1,
color: new THREE.Color(CONFIG.glassColor), attenuationColor: new THREE.Color(CONFIG.attenuationColor), attenuationDistance: CONFIG.attenuationDistance,
envMapIntensity: CONFIG.envIntensity,
})
const block = new THREE.Group()
block.rotation.order = 'YXZ'
block.add(new THREE.Mesh(blockGeo, glass))
const EW = 640, EH = Math.round(640 * bh / bw), S = 4
const EU = {
map: { value: null },
size: { value: new THREE.Vector2(EW, EH) },
tint: { value: new THREE.Color(CONFIG.engraveColor) },
opacity: { value: CONFIG.engraveOpacity },
cutY: { value: -1e4 }, // canvas rows above this are cut
rowX: { value: new THREE.Vector2() }, // the part of the row under the head that it has passed
beam: { value: 0 },
span: { value: new THREE.Vector2(0, EW) }, // the engraving's left and right edge
streak: { value: new THREE.Vector2() }, // where the head was last frame and where it is now
fire: { value: 0 },
core: { value: new THREE.Color(CONFIG.laserCore) },
glow: { value: new THREE.Color(CONFIG.laserGlow) },
}
const engraveMat = new THREE.ShaderMaterial({
uniforms: EU, vertexShader: PHOTO_VERT, transparent: true, depthWrite: false, toneMapped: false,
fragmentShader: `
uniform sampler2D map; uniform vec2 size; uniform vec3 tint; uniform float opacity;
uniform float cutY; uniform vec2 rowX; uniform float beam; uniform vec2 span; uniform vec2 streak; uniform float fire;
uniform vec3 core; uniform vec3 glow;
varying vec2 vUv;
void main() {
vec2 p = vec2(vUv.x, 1.0 - vUv.y) * size; // canvas pixels, y down
vec4 t = texture2D(map, vUv);
float row = step(cutY, p.y) * step(p.y, cutY + ${S * 2}.0) * step(rowX.x, p.x) * step(p.x, rowX.y);
float a = t.a * max(step(p.y, cutY), row);
vec3 c = tint * t.rgb * a; // premultiplied, so the laser light adds up like the canvas 'lighter' mode
if (beam > 0.0) {
float dy = abs(p.y - cutY);
float inSpan = step(span.x - 10.0, p.x) * step(p.x, span.y + 10.0);
float scan = inSpan * (0.3 * max(0.0, 1.0 - dy / 16.0) + 0.85 * step(dy, 2.5));
float ds = length(vec2(p.x - clamp(p.x, min(streak.x, streak.y), max(streak.x, streak.y)), dy));
float sGlow = 0.8 * step(ds, 10.0);
float sCore = step(ds, 3.5);
float dh = length(vec2(p.x - streak.y, dy)) / (36.0 + 42.0 * fire);
vec3 hc = dh < 0.3 ? mix(core, glow, dh / 0.3) : glow;
float ha = dh < 0.3 ? mix(1.0, 0.8 * fire, dh / 0.3) : 0.8 * fire * (1.0 - clamp((dh - 0.3) / 0.7, 0.0, 1.0));
c += beam * (glow * (scan + sGlow) + core * sCore + hc * ha);
a += beam * (scan + sGlow + sCore + ha);
}
a = clamp(a, 0.0, 1.0);
gl_FragColor = vec4(c / max(a, 0.001), a * opacity);
#include <colorspace_fragment>
}`,
})
const engravePlane = new THREE.Mesh(new THREE.PlaneGeometry(bw * 0.88, bh * 0.88), engraveMat)
engravePlane.position.z = bd / 2 + 0.003
block.add(engravePlane)
const glowCanvas = document.createElement('canvas')
glowCanvas.width = glowCanvas.height = 128
{
const g = glowCanvas.getContext('2d')
const grd = g.createRadialGradient(64, 64, 0, 64, 64, 64)
const core = hexRgb(CONFIG.laserCore), hot = hexRgb(CONFIG.laserGlow)
grd.addColorStop(0, rgba(core, 1))
grd.addColorStop(0.18, rgba(core, 0.9))
grd.addColorStop(0.32, rgba(hot, 0.7))
grd.addColorStop(1, rgba(hot, 0))
g.fillStyle = grd
g.fillRect(0, 0, 128, 128)
}
const glowTex = new THREE.CanvasTexture(glowCanvas)
glowTex.colorSpace = THREE.SRGBColorSpace
const head = new THREE.Sprite(new THREE.SpriteMaterial({ map: glowTex, transparent: true, depthWrite: false, depthTest: false, toneMapped: false, opacity: 0 }))
head.renderOrder = 2
head.position.z = bd / 2 + 0.03
block.add(head)
const SPARKS = 160
const sparkPos = new Float32Array(SPARKS * 3)
const sparkLife = new Float32Array(SPARKS)
const sparkGeo = new THREE.BufferGeometry()
sparkGeo.setAttribute('position', new THREE.BufferAttribute(sparkPos, 3).setUsage(THREE.DynamicDrawUsage))
sparkGeo.setAttribute('aLife', new THREE.BufferAttribute(sparkLife, 1).setUsage(THREE.DynamicDrawUsage))
const sparkUniforms = { uLocal: { value: 0.018 }, uScale: { value: 1 }, uHalfH: { value: 400 }, uHot: { value: new THREE.Color(CONFIG.sparkHot) }, uCool: { value: new THREE.Color(CONFIG.sparkCool) } }
const sparks = new THREE.Points(sparkGeo, new THREE.ShaderMaterial({
uniforms: sparkUniforms,
vertexShader: `
uniform float uLocal; uniform float uScale; uniform float uHalfH;
attribute float aLife;
varying float vL;
void main() {
vL = aLife;
vec4 mv = modelViewMatrix * vec4(position, 1.0);
gl_Position = projectionMatrix * mv;
gl_PointSize = aLife > 0.0 ? max(1.5, uLocal * uScale * projectionMatrix[1][1] * uHalfH / -mv.z) * (0.5 + aLife) : 0.0;
}`,
fragmentShader: `
uniform vec3 uHot; uniform vec3 uCool;
varying float vL;
void main() {
if (vL <= 0.0) discard;
float a = smoothstep(0.5, 0.1, length(gl_PointCoord - 0.5)) * vL;
gl_FragColor = vec4(mix(uCool, uHot, vL), a);
#include <colorspace_fragment>
}`,
transparent: true, depthWrite: false, depthTest: false, blending: THREE.AdditiveBlending, toneMapped: false,
}))
sparks.frustumCulled = false
sparks.renderOrder = 3
sparks.position.z = bd / 2 + 0.02
block.add(sparks)
scene.add(block)
await Promise.all([
document.fonts.load('140px "Great Vibes"'),
document.fonts.load('700 40px "Satoshi"'),
]).catch(() => {})
const markImg = root.querySelector('.eg-veil__mark')
await (markImg.decode ? markImg.decode().catch(() => {}) : Promise.resolve())
const seal = makeEngraving({ seal: markImg, script: 'making moments last' })
const engravings = [seal, ...chapters.map((c) => makeEngraving({ script: c.engrave, sub: c.sub })), seal]
engravings.forEach((e) => renderer.initTexture(e.tex)) // uploaded now, behind the veil, not mid-scroll
function makeEngraving({ seal: sealImg, script, sub }) {
const c = document.createElement('canvas')
c.width = EW; c.height = EH
const g = c.getContext('2d')
const ink = (fn) => {
g.save(); g.fillStyle = g.strokeStyle = 'rgba(28,10,40,0.5)'; g.shadowColor = 'rgba(28,10,40,0.75)'; g.shadowBlur = 30; fn(); fn(); g.restore()
g.save(); g.fillStyle = g.strokeStyle = 'rgba(28,10,40,0.6)'; g.shadowColor = 'rgba(28,10,40,0.8)'; g.shadowBlur = 6; fn(); g.restore()
g.save(); g.fillStyle = g.strokeStyle = '#ffffff'; g.shadowColor = 'rgba(255,255,255,0.6)'; g.shadowBlur = 4; fn(); g.restore()
}
const fit = (text, family, max, target) => {
let size = max
g.font = `${size}px ${family}`
while (g.measureText(text).width > target && size > 20) { size -= 4; g.font = `${size}px ${family}` }
return size
}
if (sealImg) {
const s = 300, cx = EW / 2, cy = EH * 0.4
const off = document.createElement('canvas'); off.width = off.height = s
const o = off.getContext('2d')
o.drawImage(sealImg, 0, 0, s, s)
const px = o.getImageData(0, 0, s, s)
for (let i = 0; i < px.data.length; i += 4) {
const light = px.data[i] > 200 && px.data[i + 1] > 200 && px.data[i + 2] > 200
const a = px.data[i + 3]
px.data[i] = px.data[i + 1] = px.data[i + 2] = 255
px.data[i + 3] = light ? 0 : a * 0.82
}
o.putImageData(px, 0, 0)
g.save(); g.shadowColor = 'rgba(28,10,40,0.7)'; g.shadowBlur = 28; g.drawImage(off, cx - s / 2, cy - s / 2); g.restore()
g.drawImage(off, cx - s / 2, cy - s / 2)
ink(() => { g.lineWidth = 4; g.beginPath(); g.arc(cx, cy, s / 2 + 16, 0, TAU); g.stroke() })
const size = fit(script, '"Great Vibes"', 104, EW * 0.9)
ink(() => { g.font = `${size}px "Great Vibes"`; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillText(script, cx, EH * 0.75) })
} else {
ink(() => {
g.lineWidth = 3
const m = 34, r = 26
g.beginPath(); g.roundRect ? g.roundRect(m, m, EW - m * 2, EH - m * 2, r) : g.rect(m, m, EW - m * 2, EH - m * 2); g.stroke()
})
const size = fit(script, '"Great Vibes"', 176, EW * 0.8)
ink(() => { g.font = `${size}px "Great Vibes"`; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillText(script, EW / 2, EH * 0.44) })
ink(() => {
g.textBaseline = 'middle'
const track = 7
const chars = [...sub]
const measure = () => chars.reduce((w, ch) => w + g.measureText(ch).width + track, -track)
let px = 46
g.font = `700 ${px}px Satoshi, sans-serif`
while (measure() > EW * 0.72 && px > 28) { px -= 2; g.font = `700 ${px}px Satoshi, sans-serif` }
const width = measure()
let x = (EW - width) / 2
chars.forEach((ch) => { g.fillText(ch, x, EH * 0.64); x += g.measureText(ch).width + track })
g.lineWidth = 3; g.beginPath(); g.moveTo(EW / 2 - 50, EH * 0.72); g.lineTo(EW / 2 + 50, EH * 0.72); g.stroke()
})
}
const data = g.getImageData(0, 0, EW, EH).data
const mw = EW / S | 0, mh = EH / S | 0
const mask = new Uint8Array(mw * mh)
let top = mh, bottom = 0, left = mw, right = 0
for (let y = 0; y < mh; y++) {
for (let x = 0; x < mw; x++) {
if (data[((y * S + 2) * EW + (x * S + 2)) * 4 + 3] > 90) {
mask[y * mw + x] = 1
if (y < top) top = y
if (y > bottom) bottom = y
if (x < left) left = x
if (x > right) right = x
}
}
}
const tex = new THREE.CanvasTexture(c)
tex.colorSpace = THREE.SRGBColorSpace
tex.anisotropy = Math.min(8, maxAniso)
return { tex, mask, mw, mh, y0: top * S, y1: (bottom + 1) * S, x0: left * S, x1: (right + 1) * S }
}
const laser = { eng: null, state: 'idle', t: 0, fire: 0, sparks: [], px: 0, pass: -1 }
const sparkRnd = mulberry32(5)
function engraveTo(e) {
laser.eng = e
laser.state = 'wait'
laser.t = 0
laser.fire = 0
laser.pass = -1
laser.sparks.length = 0
EU.map.value = e.tex
EU.cutY.value = -1e4
EU.beam.value = 0
EU.span.value.set(e.x0, e.x1)
head.material.opacity = 0
drawSparks()
}
function drawSparks() {
const n = Math.min(laser.sparks.length, SPARKS)
for (let k = 0; k < SPARKS; k++) {
const s = laser.sparks[k]
sparkLife[k] = k < n ? 1 - s.age / s.life : 0
if (k < n) { sparkPos[k * 3] = (s.x / EW - 0.5) * bw * 0.88; sparkPos[k * 3 + 1] = (0.5 - s.y / EH) * bh * 0.88 }
}
sparkGeo.attributes.position.needsUpdate = true
sparkGeo.attributes.aLife.needsUpdate = true
}
function burn(dt) {
const e = laser.eng
laser.t += dt
const p = clamp(laser.t / CONFIG.laserDuration)
const q = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2
const yL = e.y0 + (e.y1 - e.y0) * q
const phase = laser.t * CONFIG.laserSweep
const pass = Math.floor(phase)
const along = phase - pass
const rightward = pass % 2 === 0
const hx = rightward ? lerp(e.x0, e.x1, along) : lerp(e.x1, e.x0, along)
EU.cutY.value = yL
if (rightward) EU.rowX.value.set(0, p < 1 ? hx : 0); else EU.rowX.value.set(p < 1 ? hx : EW, EW)
const from = pass === laser.pass ? laser.px : (rightward ? e.x0 : e.x1)
laser.pass = pass
laser.px = hx
const my = clamp(Math.floor(yL / S), 0, e.mh - 2)
let inkHits = 0
if (p < 1) {
const n = Math.max(1, Math.ceil(Math.abs(hx - from) / 6))
for (let k = 0; k <= n; k++) {
const x = lerp(from, hx, k / n)
const mx = clamp(Math.floor(x / S), 0, e.mw - 1)
if (e.mask[my * e.mw + mx] || e.mask[(my + 1) * e.mw + mx]) {
inkHits++
if (sparkRnd() < 0.3) laser.sparks.push({ x, y: yL, vx: (sparkRnd() - 0.5) * 900, vy: -120 - sparkRnd() * 620, life: 0.25 + sparkRnd() * 0.45, age: 0 })
}
}
}
laser.fire += ((inkHits ? 1 : 0.6) - laser.fire) * Math.min(1, dt * 30)
EU.beam.value = p < 1 ? 1 : 0
EU.streak.value.set(from, hx)
EU.fire.value = laser.fire
for (let k = laser.sparks.length - 1; k >= 0; k--) {
const s = laser.sparks[k]
s.age += dt
s.vy += 1100 * dt
s.x += s.vx * dt
s.y += s.vy * dt
if (s.age >= s.life || s.x < 0 || s.x > EW || s.y < 0 || s.y > EH) laser.sparks.splice(k, 1)
}
drawSparks()
head.position.x = (hx / EW - 0.5) * bw * 0.88
head.position.y = (0.5 - yL / EH) * bh * 0.88
head.scale.setScalar(0.8 + 0.7 * laser.fire)
head.material.opacity = p < 1 ? Math.min(1, 0.4 + 0.6 * laser.fire) : Math.max(0, head.material.opacity - dt * 5)
if (p >= 1 && laser.sparks.length === 0) {
EU.cutY.value = 1e4
EU.beam.value = 0
head.material.opacity = 0
laser.state = 'done'
}
}
const hots = []
chapters.forEach((ch, i) => {
const g = groups[i]
const add = (shot, mesh, k, copyEl) => shot.hots.forEach((h) => {
const a = document.createElement('a')
a.className = shot.kind === 'sat' ? 'eg-hs eg-hs--sat' : 'eg-hs'
a.href = h.href
a.tabIndex = -1
a.innerHTML = `<span class="eg-hs__dot"></span><span class="eg-hs__tag">${h.html}</span>`
hotLayer.append(a)
hots.push({ el: a, mesh, u: h.u, v: h.v, k, copyEl, on: false, w: 0, flip: false, bare: false })
})
add(ch.feel, g.userData.feel, FEEL(i), ch.copyEl)
const meshes = [g.userData.main, ...g.userData.sats]
ch.shots.forEach((shot) => add(shot, meshes.find((m) => m.userData.shot === shot), SHOP(i), null))
})
function copyRight() {
const box = slotted[0] && slotted[0].slot.firstElementChild
if (!box) return 0
const left = stageEl.getBoundingClientRect().left
const r = document.createRange()
let right = 0
for (const el of box.children) {
r.selectNodeContents(el)
const b = r.getBoundingClientRect()
if (b.width) right = Math.max(right, b.right - left)
}
return right
}
function copyLines() {
const box = slotted[0] && slotted[0].slot.firstElementChild
if (!box) return []
const root = slotted[0].slot, left = stageEl.getBoundingClientRect().left
const r = document.createRange()
const lines = []
const add = (el) => {
r.selectNodeContents(el)
const b = r.getBoundingClientRect()
if (!b.width) return
let y = 0
for (let e = el; e && e !== root; e = e.offsetParent) y += e.offsetTop
lines.push({ left: b.left - left, right: b.right - left, top: y, bottom: y + el.offsetHeight })
}
for (const el of box.children) el.children.length && el.matches('h1') ? [...el.children].forEach(add) : add(el)
return lines
}
const K = []
let cw = 1, ch = 1, portrait = false
const v3 = new V3()
let hdrShown = -1
const headerShown = () => { const r = hdrEl.getBoundingClientRect(); return clamp(r.bottom, 0, r.height) }
function layout() {
const w = stageEl.clientWidth, h = stageEl.clientHeight
if (w !== cw || h !== ch) {
cw = w; ch = h
renderer.setSize(cw, ch, false)
sparkUniforms.uHalfH.value = ch * renderer.getPixelRatio() / 2
camera.aspect = cw / ch
camera.updateProjectionMatrix()
}
portrait = camera.aspect < 0.85
const hdr = hdrShown = headerShown()
const tanH = Math.tan(THREE.MathUtils.degToRad(CONFIG.fov / 2))
const vis = (d) => [2 * d * tanH * camera.aspect, 2 * d * tanH]
const key = (g, cam, look, blockAt, scale, spin, arc, lift) => {
g.updateMatrixWorld(true)
return { pos: g.localToWorld(cam.clone()), look: g.localToWorld(look.clone()), block: g.localToWorld(blockAt.clone()), scale, spin, arc, lift }
}
groups.forEach((g, i) => {
const { feel, main } = g.userData
const W = main.userData.width, H = main.userData.height
const sats = portrait ? SAT_TALL[i % SAT_TALL.length] : SAT_WIDE[i % SAT_WIDE.length]
g.userData.sats.forEach((m, j) => {
const [fx, fy, dz, rz] = sats[j] || [0, -1, 0.9, 0]
m.position.set(fx * W / 2, fy * H / 2, dz)
m.rotation.set(0, 0, rz)
})
let d, sx, sy
if (portrait) {
d = Math.max(W / (0.86 * 2 * tanH * camera.aspect), H / (0.36 * 2 * tanH))
sx = 0.5
sy = (hdr + 44 + ch * 0.53) / 2 / ch
} else {
const fw = camera.aspect < 1.35 ? 0.5 : 0.47
d = Math.max(W / (fw * 2 * tanH * camera.aspect), H / (0.71 * 2 * tanH))
sx = 0.655
sy = (ch + hdr) / 2 / ch - 0.015 // a touch above centre: the block hangs below the photo's lower corner
}
const [visW, visH] = vis(d)
const cam = new V3(-(sx - 0.5) * visW, (sy - 0.5) * visH, d)
const [cbx, cby] = BLOCK_SHOP[i % BLOCK_SHOP.length]
const blockLocal = portrait ? new V3(-0.64 * W / 2, 0.56 * H / 2, 1.7) : new V3(cbx * W / 2, cby * H / 2, 1.2)
K[SHOP(i)] = key(g, cam, new V3(cam.x, cam.y, 0), blockLocal, portrait ? 0.96 : 0.8, i + 1, 0.35, 0)
const FW = feel.userData.width, FH = feel.userData.height
const fs = chapters[i].feel
feel.position.set(0, H / 2 + FH / 2 + (portrait ? CONFIG.feelGapTall : CONFIG.feelGap), CONFIG.feelZ)
const fd = Math.min(FW / (2 * tanH * camera.aspect), FH / (2 * tanH)) * 0.985
const [fvw, fvh] = vis(fd)
const cx = feel.position.x + clamp((fs.fx - 0.5) * FW, -(FW - fvw) / 2, (FW - fvw) / 2)
const cy = feel.position.y + clamp((0.5 - fs.fy) * FH, -(FH - fvh) / 2, (FH - fvh) / 2)
const db = fd * 0.6
const [bvw, bvh] = vis(db)
const bx = portrait ? fs.pbx : fs.bx, by = portrait ? fs.pby : fs.by
const bScale = (portrait ? 0.42 * bvw / bw : 0.42 * bvh / bh) * (portrait ? 1 : fs.bs)
K[FEEL(i)] = key(g, new V3(cx, cy, feel.position.z + fd), new V3(cx, cy, feel.position.z), new V3(cx + (bx - 0.5) * bvw, cy + (0.5 - by) * bvh, feel.position.z + fd - db), bScale, i + 1, 1, 0.5)
})
const g0 = groups[0]
const d0 = K[SHOP(0)].pos.distanceTo(K[SHOP(0)].look)
const F0 = g0.userData.feel.position
const { width: FW0, height: FH0 } = g0.userData.feel.userData
const s0 = FW0 / g0.userData.main.userData.width // keep the framing the shop row had, scaled to the wider moments
const at = (x, y, z) => new V3(F0.x + x, F0.y + y, F0.z + z)
if (portrait) {
const d = FW0 / (0.84 * 2 * tanH * camera.aspect)
const [, visH] = vis(d)
const sy = FH0 / visH / 2 + 0.035 // at scroll 0 the stage already starts below the top bar and header
const cam = at(-0.04 * vis(d)[0], (sy - 0.5) * visH, d)
K[0] = key(g0, cam, new V3(cam.x, cam.y, F0.z), at(-0.4 * FW0 / 2, -0.95 * FH0 / 2, d * 0.33), 0.95 * s0, 0, 1, 0)
K[L] = key(g0, new V3(0, 13.5, 40), new V3(-2.5, 12.5, -6), new V3(-0.3, 14.2, 28), 0.75, N + 1, 2.4, 2)
} else {
const top0 = clamp(story.getBoundingClientRect().top + window.scrollY, 0, ch * 0.4)
const visible = ch - top0
const m = clamp(ch * 0.04, 18, 40)
const xL = Math.max(copyRight(), cw * 0.34) + Math.max(40, cw * 0.03)
const ratio = FW0 / FH0
const hp = Math.min(visible - 2 * m, (cw - m - xL) / ratio)
const wp = hp * ratio
const px = (xL + cw - m) / 2, py = visible / 2
const d = FH0 * ch / (hp * 2 * tanH)
const [visW, visH] = vis(d)
const camX = -((px - cw / 2) / cw) * visW, camY = ((py - ch / 2) / ch) * visH
const db = d * 0.55
const [bvw, bvh] = vis(db)
const bhp = 0.42 * hp, bwp = bhp * bw / bh, gap = clamp(cw * 0.02, 24, 40)
const lines = copyLines()
const hits = (x, y) => lines.some((r) => x - bwp / 2 < r.right + gap && x + bwp / 2 > r.left - gap && y - bhp / 2 < r.bottom + gap && y + bhp / 2 > r.top - gap)
let bxp = px - wp / 2 - 0.12 * bwp
let byp = py - hp / 2 + 0.03 * hp + bhp / 2
const yMin = Math.max(py - hp / 2 - 0.05 * hp, m) + bhp / 2
while (hits(bxp, byp) && byp - 4 >= yMin) byp -= 4
while (hits(bxp, byp) && bxp < px - wp / 2 + 0.5 * bwp) bxp += 4
const bScale = (bhp / ch) * bvh / bh
K[0] = key(g0, at(camX, camY, d), at(camX, camY, 0), at(camX + ((bxp - cw / 2) / cw) * bvw, camY - ((byp - ch / 2) / ch) * bvh, d - db), bScale, 0, 1, 0)
K[L] = key(g0, new V3(3.6, 10, 23), new V3(-12.4, 9.7, -14), new V3(3, 8.3, 9), 0.85, N + 1, 2.4, 2)
}
hots.forEach((h) => { h.w = 0 })
}
const camPos = new V3()
const camLook = new V3()
const blockPos = new V3()
const tPos = new V3(), tLook = new V3(), tBlock = new V3()
let spin = 0, scale = 1, fShown = 0, entered = false, engraveIndex = 0, frost = 0
let allLoaded = false
let mode = 'track', transitOp = 0, transitStop = -1, labelT = 0, fFrom = 0, fPrev = 0, restT = 0
let calm = true, shownPrev = 0, shownVel = 0
const pointer = { x: 0, y: 0, sx: 0, sy: 0 }
const cssState = { feel: '', scrim: '', dark: false, active: -2, finale: false, nav: false, progress: '', transit: '' }
window.addEventListener('pointermove', (e) => {
if (e.pointerType !== 'mouse') return
pointer.x = (e.clientX / window.innerWidth) * 2 - 1
pointer.y = -(e.clientY / window.innerHeight) * 2 + 1
}, { passive: true })
navLinks.forEach((a) => a.addEventListener('click', (e) => {
const t = document.querySelector(a.getAttribute('href'))
if (!t) return
e.preventDefault()
t.scrollIntoView({ behavior: 'smooth', block: 'start' })
}))
function progress() {
const r = story.getBoundingClientRect()
const total = r.height - window.innerHeight
return total > 0 ? clamp(-r.top / total) * L : 0
}
function targets(f) {
const j = Math.min(Math.floor(f), L - 1)
const u = clamp(f - j)
const e = smoother(clamp((u - 0.16) / 0.68))
const s = Math.sin(Math.PI * e)
const A = K[j], B = K[j + 1]
tPos.lerpVectors(A.pos, B.pos, e)
tPos.y += B.lift * s
tPos.z += CONFIG.pullBack * B.arc * s
tLook.lerpVectors(A.look, B.look, smoother(clamp(e * 1.3))) // the camera turns toward where it is going before it arrives
tBlock.lerpVectors(A.block, B.block, e)
tBlock.y += 0.8 * B.arc * s
tBlock.z += 0.8 * B.arc * s
return { spin: lerp(A.spin, B.spin, e) * TAU, scale: lerp(A.scale, B.scale, e) }
}
function transitLabel(stop, now) {
if (stop === transitStop || (!now && labelT < 0.08)) return // ticks like a counter, never a flicker
transitStop = stop
labelT = 0
let kicker = '', title = ''
if (stop >= L) title = finaleSlot.querySelector('h2').textContent.trim()
else if (stop > 0) {
const i = Math.floor((stop - 1) / 2)
kicker = `${String(i + 1).padStart(2, '0')} / ${String(N).padStart(2, '0')}${stop === SHOP(i) ? ' · Produkter' : ''}`
title = navLinks[i].textContent.trim()
}
transitKicker.textContent = kicker
transitTitle.textContent = title
}
function placeStart() {
const t = targets(progress())
camPos.copy(tPos).add(v3.set(0, 2.2, 10))
camLook.copy(tLook)
blockPos.copy(tBlock).add(v3.set(0, -5, 1))
spin = t.spin - TAU
scale = t.scale
fShown = progress()
}
let last = performance.now()
let running = false
let raf = 0
const camDir = new V3()
const toCam = new V3(), lookAt = new V3()
function tick(now) {
raf = requestAnimationFrame(tick)
const dt = (now - last) / 1000
frame(now)
if (entered) adapt(dt)
}
const quality = { min: Math.min(window.devicePixelRatio, 1), sum: 0, n: 0, wait: 2.5, before: 0, locked: false }
function setPixelRatio(pr) {
renderer.setPixelRatio(pr)
sparkUniforms.uHalfH.value = ch * pr / 2
dustUniforms.uSize.value = CONFIG.dustSize * pr
quality.wait = 0.6 // the resize itself costs a frame; let it pass before measuring again
}
function adapt(dt) {
if (quality.locked || dt <= 0 || dt > 0.5) return
if (quality.wait > 0) { quality.wait -= dt; return }
quality.sum += dt
quality.n++
if (quality.sum < 1.2) return
const avg = quality.sum / quality.n
quality.sum = quality.n = 0
const pr = renderer.getPixelRatio()
if (quality.before) {
if (avg > quality.before * 0.9) { setPixelRatio(pr + 0.25); quality.locked = true; return }
quality.before = 0
}
if (avg > 1 / 50 && pr - 0.25 >= quality.min) { quality.before = avg; setPixelRatio(pr - 0.25) }
}
function frame(now, draw = true) {
const dt = Math.min(0.1, (now - last) / 1000)
last = now
if (Math.abs(headerShown() - hdrShown) > 1.5) layout()
const time = now / 1000
const f = progress()
const speed = dt > 0 ? Math.abs(f - fPrev) / dt : 0
fPrev = f
labelT += dt
if (entered) {
const far = Math.abs(f - fShown) > CONFIG.travelGap && Math.abs(Math.round(f) - Math.round(fShown)) >= 2
if (far && (mode === 'track' || mode === 'in')) { mode = 'out'; fFrom = fShown; restT = 0 }
if (mode === 'out' || mode === 'hold') {
if (Math.abs(f - fFrom) < 0.5) mode = 'in' // back where it left: lift the dip over the same scene
else {
transitOp = Math.min(1, transitOp + dt / CONFIG.transitOut)
if (transitOp >= 1) mode = 'hold'
restT = speed < CONFIG.landSpeed ? restT + dt : 0
if (mode === 'hold' && restT > 0.14) {
const fl = clamp(f - Math.sign(f - fFrom) * CONFIG.landRun, 0, L)
const tl = targets(fl)
camPos.copy(tPos)
camLook.copy(tLook)
blockPos.copy(tBlock)
spin = tl.spin
scale = tl.scale
fShown = shownPrev = fl
transitLabel(Math.round(f), true)
mode = 'in'
}
}
}
if (mode === 'in') { transitOp = Math.max(0, transitOp - dt / CONFIG.transitIn); if (transitOp === 0) mode = 'track' }
if (transitOp > 0 && mode !== 'in') transitLabel(Math.round(f))
}
const t = targets(f)
const kc = 1 - Math.exp(-CONFIG.camDamp * dt)
const kb = 1 - Math.exp(-CONFIG.blockDamp * dt)
if (entered && (mode === 'track' || mode === 'in')) { // while dipping, the last frame holds still under the ground
pointer.sx += (pointer.x - pointer.sx) * kc
pointer.sy += (pointer.y - pointer.sy) * kc
tPos.x += pointer.sx * CONFIG.parallax
tPos.y += pointer.sy * CONFIG.parallax * 0.6
camPos.lerp(tPos, kc)
camLook.lerp(tLook, kc)
blockPos.lerp(tBlock, kb)
spin += (t.spin - spin) * kb
scale += (t.scale - scale) * kb
fShown += (f - fShown) * kc
}
if (dt > 0) shownVel += (Math.abs(fShown - shownPrev) / dt - shownVel) * (1 - Math.exp(-dt / 0.1))
shownPrev = fShown
if (calm && (shownVel > 1.2 || transitOp > 0.3)) calm = false
else if (!calm && shownVel < 0.6 && transitOp < 0.3) calm = true
camera.position.copy(camPos)
camera.lookAt(camLook)
block.position.copy(blockPos)
block.position.y += Math.sin(time * 0.9) * 0.05
toCam.copy(camera.position).sub(block.position)
const reach = toCam.length() * CONFIG.lookReach
const w = 1 - CONFIG.lookCentre
lookAt.set(pointer.sx * w, pointer.sy * w, 0.5).unproject(camera).sub(camera.position).normalize()
.multiplyScalar(reach).add(camera.position).sub(block.position)
const yawCam = Math.atan2(toCam.x, toCam.z), pitchCam = Math.atan2(toCam.y, Math.hypot(toCam.x, toCam.z))
const dYaw = ((Math.atan2(lookAt.x, lookAt.z) - yawCam + Math.PI * 3) % TAU) - Math.PI
const dPitch = Math.atan2(lookAt.y, Math.hypot(lookAt.x, lookAt.z)) - pitchCam
const yaw = yawCam + clamp(dYaw, -CONFIG.lookYaw, CONFIG.lookYaw)
const pitch = pitchCam + clamp(dPitch, -CONFIG.lookPitch, CONFIG.lookPitch)
block.rotation.set(Math.sin(time * 0.45) * 0.05 - pitch, yaw + spin + Math.sin(time * 0.6) * 0.1, 0)
block.scale.setScalar(scale)
sparkUniforms.uScale.value = scale
const turns = spin / TAU
const idx = clamp(Math.round(turns), 0, N + 1)
if (idx !== engraveIndex || !laser.eng) { engraveIndex = idx; engraveTo(engravings[idx]) }
if (laser.state === 'wait' && entered && Math.abs(turns - Math.round(turns)) < 0.07) { laser.state = 'burn'; laser.t = 0 }
if (laser.state === 'burn') burn(dt)
for (let k = fading.length - 1; k >= 0; k--) {
fading[k].loaded.value = Math.min(1, fading[k].loaded.value + dt * 2.2)
if (fading[k].loaded.value >= 1) fading.splice(k, 1)
}
camera.getWorldDirection(camDir)
dustUniforms.uCentre.value.copy(camPos).addScaledVector(camDir, DUST_BOX.z * 0.4)
dustUniforms.uTime.value = time
const intro = clamp(1 - fShown * 1.6)
const finale = clamp(1 - (L - fShown) * 1.6)
const edgeFocus = clamp(1 - (L - fShown) * 1.4) * 0.85
const hide = (m, amt) => {
m.visible = amt < 0.97 // a photo in the ground colour still shows its edge against the backdrop glow
m.userData.uniforms.fade.value = lerp(CONFIG.unfocusFade, 1, amt)
m.userData.shadow.value = m.userData.shadowBase * (1 - amt)
}
const shopHide = Math.max(intro, finale)
let feelAmt = 0, frostTo = 0
groups.forEach((g, i) => {
const near = (k) => clamp(1 - Math.max(0, Math.abs(fShown - k) - 0.12) * 1.6)
g.userData.feel.userData.uniforms.focus.value = Math.max(near(FEEL(i)), edgeFocus, i === 0 ? intro : 0)
const shop = Math.max(near(SHOP(i)), edgeFocus)
g.userData.main.userData.uniforms.focus.value = shop
g.userData.sats.forEach((m) => { m.userData.uniforms.focus.value = shop })
if (i > 0) hide(g.userData.feel, intro)
hide(g.userData.main, shopHide)
g.userData.sats.forEach((m) => hide(m, shopHide))
feelAmt = Math.max(feelAmt, clamp(1 - Math.abs(fShown - FEEL(i)) * 2.2))
if (chapters[i].frost && Math.abs(fShown - SHOP(i)) < 0.12) frostTo = 1
const on = entered && calm && Math.abs(fShown - FEEL(i)) < 0.3
if (on !== chapters[i].on) { chapters[i].on = on; chapters[i].feelEl.classList.toggle('eg-is-on', on) }
})
if (finaleEl.hasAttribute('data-frost') && fShown > L - 0.12) frostTo = 1
frost = frostTo > frost ? Math.min(frostTo, frost + dt / CONFIG.frostIn) : Math.max(frostTo, frost - dt / CONFIG.frostOut)
glass.roughness = lerp(CONFIG.roughness, CONFIG.frostRoughness, smoother(frost))
const finaleOn = entered && calm && fShown > L - 0.35
if (finaleOn !== cssState.finale) { cssState.finale = finaleOn; finaleSlot.classList.toggle('eg-is-on', finaleOn) }
slotted.forEach((x, k) => {
const on = calm && Math.abs(fShown - k) < 0.24
if (on !== x.on) { x.on = on; x.slot.classList.toggle('eg-is-active', on) }
})
const fUi = lerp(fShown, f, transitOp)
const opVar = (mode === 'in' ? transitOp * transitOp : transitOp).toFixed(3)
if (opVar !== cssState.transit) {
cssState.transit = opVar
transitEl.style.opacity = opVar
transitEl.style.visibility = transitOp > 0 ? 'visible' : 'hidden'
transitEl.style.setProperty('--card', (mode === 'in' ? clamp((transitOp - 0.55) / 0.45) : clamp((transitOp - 0.35) / 0.5)).toFixed(3))
}
const navOn = fUi > 0.6 && fUi < L - 0.6
if (navOn !== cssState.nav) { cssState.nav = navOn; stageEl.classList.toggle('eg-is-nav', navOn) }
const feelVar = feelAmt.toFixed(3)
const scrimVar = Math.max(portrait ? clamp(1 - fShown * 2.4) : 0, clamp(1 - (L - fShown) * 2.4)).toFixed(3)
if (feelVar !== cssState.feel) { cssState.feel = feelVar; stageEl.style.setProperty('--feel', feelVar) }
if (scrimVar !== cssState.scrim) { cssState.scrim = scrimVar; stageEl.style.setProperty('--scrim', scrimVar) }
const progressVar = clamp(fUi / L).toFixed(4)
if (progressVar !== cssState.progress) { cssState.progress = progressVar; stageEl.style.setProperty('--progress', progressVar) }
const dark = feelAmt > 0.5 && transitOp < 0.5 // the dip is the light ground
if (dark !== cssState.dark) { cssState.dark = dark; stageEl.classList.toggle('eg-is-dark', dark) }
let active = -1
for (let i = 0; i < N; i++) if (fUi >= FEEL(i) - 0.5 && fUi < SHOP(i) + 0.5) active = i
if (active !== cssState.active) {
cssState.active = active
navLinks.forEach((a, i) => { if (i === active) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current') })
}
placeHotspots()
if (draw && mode !== 'hold') renderer.render(scene, camera)
}
function placeHotspots() {
const stageRect = stageEl.getBoundingClientRect()
const copyRects = new Map()
const moves = []
for (const h of hots) {
const near = entered && calm && Math.abs(fShown - h.k) < 0.24
let show = false
if (near) {
const { width, height } = h.mesh.userData
v3.set((h.u - 0.5) * width, (0.5 - h.v) * height, 0.02)
h.mesh.localToWorld(v3)
v3.project(camera)
const x = (v3.x * 0.5 + 0.5) * cw
const y = (-v3.y * 0.5 + 0.5) * ch
show = v3.z < 1 && x > 8 && x < cw - 8 && y > 70 && y < ch - 8 - bottomInset
if (show && h.copyEl) {
if (!copyRects.has(h.copyEl)) copyRects.set(h.copyEl, h.copyEl.getBoundingClientRect())
const r = copyRects.get(h.copyEl)
if (y > r.top - stageRect.top - 28 && x < r.right - stageRect.left + 12) show = false
}
if (show) {
if (!h.w) h.w = h.el.offsetWidth
moves.push([h, x, y])
}
}
if (!show && h.on) moves.push([h])
}
for (const [h, x, y] of moves) {
if (x === undefined) { h.el.classList.remove('eg-is-on'); h.on = false; continue }
if (!h.on) { h.el.classList.add('eg-is-on'); h.on = true }
const fitsRight = x - 11 + h.w <= cw - 8
const flip = !fitsRight && x + 11 - h.w >= 8
const bare = !fitsRight && !flip
if (flip !== h.flip) { h.el.classList.toggle('eg-hs--flip', flip); h.flip = flip }
if (bare !== h.bare) { h.el.classList.toggle('eg-hs--bare', bare); h.bare = bare }
h.el.style.transform = `translate3d(${(flip ? x - h.w + 11 : x - 11).toFixed(1)}px, ${(y - 22).toFixed(1)}px, 0)`
}
}
const capture = new URLSearchParams(location.search).has('capture')
let clock = performance.now()
if (capture) {
const stepAnimations = (dt) => {
for (const a of document.getAnimations()) {
if (!a.egStepped) { a.egStepped = true; a.pause(); a.currentTime = 0; continue }
a.currentTime += dt * 1000
if (a.currentTime >= a.effect.getComputedTiming().endTime) a.finish()
}
}
window.__egStep = (dt, draw = true) => { clock += dt * 1000; frame(clock, draw); stepAnimations(dt) }
window.__egLoaded = () => allLoaded
window.__egLaser = () => ({ state: laser.state, t: laser.t })
}
const start = () => { if (!running && !capture) { running = true; last = performance.now(); quality.sum = quality.n = 0; raf = requestAnimationFrame(tick) } }
const stop = () => { if (running) { running = false; cancelAnimationFrame(raf) } }
new IntersectionObserver(([e]) => (e.isIntersecting ? start() : stop())).observe(story)
new ResizeObserver(() => { layout(); if (!entered) placeStart() }).observe(stageEl)
document.fonts.ready.then(() => { layout(); if (!entered) placeStart() })
matchMedia('(prefers-color-scheme: dark)').addEventListener('change', readGround)
reduceMotion.addEventListener('change', (e) => { if (e.matches) { stop(); toStatic() } })
layout()
placeStart()
engraveTo(engravings[0])
await Promise.all(jobs.filter((j) => j.group === 0).map((j) => loadTexture(j, true).catch(() => {})))
;(async () => {
for (const j of jobs.filter((x) => x.group > 0)) await loadTexture(j, false).catch(() => {})
allLoaded = true
})()
renderer.compile(scene, camera)
renderer.render(scene, camera)
await new Promise((r) => requestAnimationFrame(() => r()))
return {
enter() {
if (entered) return
entered = true
start()
},
}
}
